import React, { Component } from 'react';
import ToDo from './ToDo';
import {NavLink} from 'react-router-dom';



class Home extends Component {
   constructor(props) {
    super(props);
    this.props = props;  
    this.state= {width :1, height:1} 
  }
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }
  componentWillUnmount(){
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }
  updateDimensions() {
    if(window.innerWidth < 500) {
      this.setState({ width: 450, height: 102 });
    } else {
      let update_width  = window.innerWidth-100;
      let update_height = Math.round(update_width/4.4);
      this.setState({ width: update_width, height: update_height });
    }
  }
  render(){
    console.log(this.state.width);
     
    let TX =(this.state.width / 1440*2);
    let TY =(.8);
    
    console.log(this.width)
    if(this.state.width <= 604){
      TX =(this.state.width * 3.2 / 1440) *.8;
      TY =(.8);
        }
    let style = 'height:25rem; -webkit-transform:scale(' + TX + ',' + TY+'); -moz-transform-scale("' + TX + '","' + TY +'" );'; 
    //   style = 'height:200px;width=200px;' 
    //  }
    
    // console.log(TX);

   
    


    return (  
    <div className='fluid-container pb-3 px-3'> 
    <div className='row justify-content-center'>
    
    <div className='col-12' Style="min-width: 200px">
    <iframe Title="AntBall" Style={style} width='100%'    scrolling='no' src="./AntBall/index.html"></iframe>
    </div>
    </div>
    
    <div className='row justify-content-center'>
    
    <div className='col-6' Style="min-width: 200px">
    <h2>OLD SCHOOL ???</h2>
    <h4>Retro, maybe even "HARD CORE". Characters may die. Loot may be lost. However, the finest treasure will be found: FUN!</h4>
    </div>
    <div className='col-6' Style="min-width: 200px">
    <h2>FREE ???</h2>
    <h4>Yep No Gimics, no cash grabs, just fun and free, there may be a shop someday but, it won't interfere with the freeness or game play on the site.</h4>
    </div>  
    <div className='col-6' Style="min-width: 200px">
    <h2>GAMES ???</h2>
    
    <h4>Single Player, Multi Player, Loot Crawlers, Rogue Likes, Action, etc... I like games, do you like games, lets make and play some, shall we???</h4>
    
    </div>
    
    {(!this.props.data.usr)?(<div className='col-6' Style="min-width: 200px">
    <NavLink to='/register'><h2>REGISTER NOW !!!</h2></NavLink>
    <h4><NavLink to='/register'>Registration</NavLink> gives you <NavLink to='/register'>access</NavLink> to our current and up and coming <NavLink to='/register'>games</NavLink>. No worries, <NavLink to="/privacy"> your email is safe with us </NavLink>, we will never sell it or use it for spam.</h4>
    </div>):(<div className='col-6'>
    <h2>COMING SOON ...</h2>
    <NavLink to='/soon'><h4>Working Hard noooooooooow, Making Game noooooooooow... website tooooooo... how bout you???? da na na na nuuuu?</h4></NavLink>
    </div>)}
      
    
    </div>
    
    
  
    {(!this.props.data.usr.hasAdmin)?'':(<ToDo data = {this.props.data}/>)}
    
  
  
    
    </div>
    
  
  )
}

  }
  
export default Home;  


// WEBPACK FOOTER //
// ./src/container/Pages/Home.js